<template>
  <div>
    <formPackaging
      ref="formPackaging"
      :searchFormList="searchFormList"
      @update="searchData"
      v-if="searchFormList.length"
    ></formPackaging>

    <div class="table-wrap">
      <slot name="header"></slot>
      <!-- 表格部分 -->
      <el-table
        :data="tableListData"
        stripe
        border
        ref="table"
        :default-sort="{ prop: 'date', order: 'descending' }"
        @select="handleSelectionChange"
      >
        <!-- 表格业务内容列 -->
        <template v-for="(item, index) of tableOption">
          <el-table-column
            v-if="!item.otherType"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :align="item.align || 'center'"
            :show-overflow-tooltip="item.overHidden || false"
            :min-width="item.width || ''"
            :sortable="item.sortable || false"
            :type="item.type || 'normal'"
          ></el-table-column>

          <el-table-column
            v-if="item.otherType == 'fromContinent'"
            :key="index"
            :label="item.label"
            :min-width="item.width || ''"
            :align="item.align || 'center'"
            :show-overflow-tooltip="item.overHidden || false"
          >
            <template slot-scope="scope">
              <span v-if="scope.row[item.prop].length">
                {{
                  scope.row[item.prop]
                    .map((e) => {
                      return e.continentName;
                    })
                    .join('、')
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="item.otherType == 'calendarDate'"
            :key="index"
            :label="item.label"
            :min-width="item.width || ''"
            :align="item.align || 'center'"
            :show-overflow-tooltip="item.overHidden || false"
          >
            <template slot-scope="scope">
              <el-tag
                :disable-transitions="false"
                v-for="continent in scope.row.calendarList"
                :key="continent.countryCalendarBid"
                closable
                :type="continent.countryCalendarBid"
                @close="continentRemoveClick(continent, scope)"
              >
                {{ continent.date }}
              </el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column
            v-if="item.otherType == 'informationType'"
            :key="index"
            :label="item.label"
            :align="item.align || 'center'"
            :show-overflow-tooltip="item.overHidden || false"
          >
            <template slot-scope="scope">
              {{
                scope.row[item.prop] == 0
                  ? '无识别'
                  : scope.row[item.prop] == 1
                  ? '人脸识别'
                  : scope.row[item.prop] == 2
                  ? '身份证识别'
                  : '护照识别'
              }}
            </template>
          </el-table-column> -->
          <el-table-column
            v-if="item.otherType == 'titlePictureUrl'"
            :key="index"
            :label="item.label"
            :align="item.align || 'center'"
          >
            <template slot-scope="scope">
              <el-tooltip placement="top" popper-class="atooltip">
                <div slot="content">
                  <img :src="scope.row[item.prop]" alt="" />
                </div>
                <div class="img">
                  <img :src="scope.row[item.prop]" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            v-if="item.otherType == 'exampleFileUrl'"
            :key="index"
            :label="item.label"
            :align="item.align || 'center'"
          >
            <template slot-scope="scope">
              <el-tooltip
                placement="top"
                popper-class="atooltip"
                v-if="!scope.row.exampleType"
              >
                <div slot="content">
                  <img :src="scope.row[item.prop]" alt="" />
                </div>
                <div class="img">
                  <img :src="scope.row[item.prop]" alt="" />
                </div>
              </el-tooltip>
              <el-link
                type="primary"
                v-else-if="scope.row.exampleType != 2"
                :href="scope.row[item.prop]"
                :underline="false"
                target="_blank"
                >查看</el-link
              >
            </template>
          </el-table-column>
          <el-table-column
            v-if="item.otherType == 'hasTicket'"
            :key="index"
            :label="item.label"
            :align="item.align || 'center'"
            :min-width="item.width || ''"
            :show-overflow-tooltip="item.overHidden || false"
          >
            <template slot-scope="scope">
              {{ scope.row[item.prop] ? '是' : '否' }}
            </template>
          </el-table-column>
          <!-- <el-table-column  
            v-if="item.otherType == 'tooltip'"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :align="item.align || 'center'"
            :show-overflow-tooltip="item.overHidden || false"
            :min-width="item.width || ''"
            :sortable="item.sortable || false"
            :type="item.type || 'normal'"
            :render-header="icons"
          ></el-table-column> -->
          <!-- <el-table-column
            v-if="item.otherType == 'status'"
            :key="index"
            :label="item.label"
            :align="item.align || 'center'"
            :show-overflow-tooltip="item.overHidden || false"
          >
            <template slot-scope="scope">
              <span
                v-if="
                  item.prop == 'inspectionType' ||
                  (item.propTwo == 'inspectionType' &&
                    scope.row[item.propTwo] == 2) ||
                  item.prop == 'timeType' ||
                  item.prop == 'workTaskState' ||
                  item.prop == 'isFinish'
                "
              >
                {{ item.list[scope.row[item.prop] - 1] }}
                <span v-if="scope.row[item.prop] == 9"> 超时未完成 </span>
              </span>
              <span
                v-else-if="
                  item.propTwo == 'inspectionType' &&
                  scope.row[item.propTwo] == 1
                "
              >
                {{ scope.row[item.prop] }}
              </span>
              <span v-else>
                {{ scope.row[item.prop] ? item.list[1] : item.list[0] }}
              </span>
            </template>
          </el-table-column> -->

          <!-- <el-table-column
          v-if="item.otherType == 'switch'"
          :key="index"
          :label="item.label"
          :align="item.align || 'center'"
          :show-overflow-tooltip="item.overHidden || false"
        >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.showInBubble"
              @change="swtichChange(scope.row)"
              >
            </el-switch>
          </template>
        </el-table-column> -->
          <!-- <el-table-column
            v-if="item.otherType == 'picture'"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :align="item.align || 'center'"
            :show-overflow-tooltip="item.overHidden || false"
            :min-width="item.width || ''"
            :sortable="item.sortable || false"
            :type="item.type || 'normal'"
          >
            <template slot-scope="scope">
              <el-tooltip placement="top" popper-class="atooltip">
                <div slot="content">
                  <img :src="scope.row[item.prop]" alt="" />
                </div>
                <div class="img">
                  <img :src="scope.row[item.prop]" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column> -->
          <!-- <el-table-column
            v-if="item.otherType == 'array'"
            :key="index"
            :label="item.label"
            :show-overflow-tooltip="item.overHidden || false"
            :align="item.align || 'center'"
          >
            <template slot-scope="scope">
              <span v-if="scope.row[item.prop].length">
                {{
                  scope.row[item.prop]
                    .map((e) => {
                      return e[item.showName];
                    })
                    .join('、')
                }}
              </span>
              <span v-if="scope.row[item.prop].length == 0">
                {{ item.arraynull }}
              </span>
            </template>
          </el-table-column> -->
        </template>
        <!-- 表格操作列 -->
        <el-table-column label="操作" v-if="isOperate" min-width="150px">
          <template slot-scope="scope">
            <slot name="operate" :row="scope.row"></slot>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap" v-if="pageSet.totalCount > 0">
        <div>
          <span>共</span>
          <span>{{ pageSet.totalCount }}</span>
          <span>条,</span>
          <span
            >每页显示
            <el-select
              v-model="pageSize"
              placeholder="请选择"
              @change="pageSizeChange"
              size="small"
            >
              <el-option
                v-for="item in pageNumberList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option> </el-select
            >条</span
          >
        </div>
        <div class="pagination-left" v-if="pageSet.totalCount > pageSize">
          <span>共{{ Math.ceil(pageSet.totalCount / pageSize) }}页</span>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="pageSet.pageNum"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="pageSet.totalCount"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formPackaging from '@/components/formPackaging';
// import {updateShowOrNot} from '@/api/equipment-template-data-type'

export default {
  data() {
    return {
      pageSet: {},
      pageSize: 10,
      pageNumberList: [
        { lable: 10, value: 10 },
        { lable: 20, value: 20 },
        { lable: 50, value: 50 },
        { lable: 100, value: 100 },
      ],
    };
  },
  // 父组件向子组件传值
  props: {
    // 表格显示的数据
    tableListData: {
      type: Array,
      default: function () {
        return [];
      },
    },
    searchFormList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    // 表格的操作
    tableOption: {
      type: Array,
      default: function () {
        return [];
      },
    },
    // 控制操作列是否显示
    isOperate: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    page: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  created() {},
  mounted() {
    // Object.assign(this.pageSet,this.page)
  },
  methods: {
    //日历关闭
    continentRemoveClick(item) {
      this.$emit('deleteDate', item);
    },
    // swtichChange(item){
    //   console.log(item.showInBubble)
    //   // /template/dataType/updateShowOrNot
    //   let data = {
    //     dataTypeBid:item.dataTypeBid,
    //     show: item.showInBubble
    //   }
    //   updateShowOrNot(data).then(res => {
    //     if(res.code == 200){
    //       console.log('变更成功')
    //     }
    //   })
    // },
    handleSelectionChange(selection, row) {
      // console.log(selection, row);
      // //选中还是取消
      // if (selection.includes(row)) {
      //   if (!this.checkedList.includes(row)) {
      //     this.checkedList.push(row);
      //   }
      // } else {
      //   this.checkedList.forEach((val, inx) => {
      //     if (val.ID_ == row.ID_) {
      //       this.checkedList.splice(inx, 1);
      //     }
      //   });
      // }
      this.$emit('deleteList', selection);
    },
    pageSizeChange(eve) {
      this.pageSet.pageSize = eve;
      this.$emit('update', this.pageSet);
    },
    //只控制分页器的
    handleCurrentChange(val) {
      this.pageSet.pageNum = val;
      this.$emit('update', this.pageSet);
    },
    //控制表单查询
    searchData(data) {
      console.log(data);
      this.$emit('searchDate', data);
    },
    // noicons() {},
    // icons(h, { column }) {
    //   const inReview = '数值越大，排序越靠前！';
    //   return h('div', [
    //     h('span', column.label),
    //     h(
    //       'el-tooltip',
    //       {
    //         props: {
    //           placement: 'top',
    //         },
    //       },
    //       [
    //         h(
    //           'div',
    //           {
    //             slot: 'content',
    //             style: {
    //               whiteSpace: 'normal',
    //             },
    //           },
    //           inReview
    //         ),
    //         h('i', {
    //           class: 'el-icon-warning-outline',
    //           style: 'margin-left:5px;',
    //         }),
    //       ]
    //     ),
    //   ]);
    // },
  },
  components: {
    formPackaging,
  },
  watch: {
    page: {
      handler(newValue) {
        // console.log(newValue)
        Object.assign(this.pageSet, newValue);
      },
      deep: true,
      immediate: true, //router.go(-1)返回后就开始监听
    },
  },
};
</script>

<style lang="scss" scoped>
.el-pagination__jump {
  margin-left: 0;
}
.el-tag {
  margin-right: 5px;
}
.table-img {
  width: 30px;
  height: 30px;
}
</style>
